export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/54862500-60ce-4f78-8565-2235f542b77c.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/704ede13-196a-4590-acae-23263897a446.png',
};
